import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';

// La tabla usa color = color fuerte (borde) y color_fondo = pastel.
// Aquí se traduce al formato que usan los componentes.
const aCategoriaApp = (r) => ({
  id: r.id,
  nombre: r.nombre,
  icono: r.icono || '📦',
  color: r.color_fondo || '#F3F4F6',
  borde: r.color || '#9CA3AF',
  prefijo: r.prefijo_codigo,
  orden: r.orden,
});

export async function obtenerCategorias() {
  // Solo categorías de PRODUCTO. Las de servicio (tipo 'servicio') las maneja
  // serviciosService, para no mezclarlas en el inventario/catálogo de productos.
  const { data, error } = await supabase
    .from('categorias')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .eq('tipo', 'producto')
    .order('orden', { ascending: true });
  if (error) throw error;
  return (data || []).map(aCategoriaApp);
}

export async function crearCategoria({ nombre, prefijo, icono, color, borde, orden }) {
  const { error } = await supabase.from('categorias').insert([{
    negocio_id: getNegocioId(),
    nombre: nombre.trim(),
    prefijo_codigo: prefijo.trim().toUpperCase(),
    icono: icono || '📦',
    color: borde || '#9CA3AF',
    color_fondo: color || '#F3F4F6',
    orden,
  }]);
  if (error) throw error;
}

// Al renombrar una categoría también se actualizan los productos
// que la usan (productos.categoria guarda el nombre).
export async function actualizarCategoria(id, { nombre, icono, nombreAnterior }) {
  const { error } = await supabase
    .from('categorias')
    .update({ nombre: nombre.trim(), icono })
    .eq('id', id);
  if (error) throw error;
  if (nombreAnterior && nombreAnterior !== nombre.trim()) {
    const { error: e2 } = await supabase
      .from('productos')
      .update({ categoria: nombre.trim() })
      .eq('negocio_id', getNegocioId())
      .eq('categoria', nombreAnterior);
    if (e2) throw e2;
  }
}

export async function contarProductosDeCategoria(nombreCategoria) {
  const { count, error } = await supabase
    .from('productos')
    .select('id', { count: 'exact', head: true })
    .eq('negocio_id', getNegocioId())
    .eq('categoria', nombreCategoria);
  if (error) throw error;
  return count || 0;
}

export async function eliminarCategoria(id) {
  const { error } = await supabase.from('categorias').delete().eq('id', id);
  if (error) throw error;
}
